// src/cockpit/useCockpit.ts
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../lib/api'
import type { CockpitData } from '../lib/types'

export function useCockpit(appId: string | null) {
  return useQuery<CockpitData, Error>({
    queryKey: ['cockpit', appId],
    queryFn: () => api.get<CockpitData>(`/api/cockpit?appId=${appId}`),
    enabled: Boolean(appId),
    staleTime: 1000 * 60,
  })
}

export type ManualStatInput = { metric: 'd30_retention' | 'crash_free'; value: number }

export function useSetManualStat(appId: string | null) {
  const qc = useQueryClient()
  return useMutation<{ ok: boolean }, Error, ManualStatInput>({
    mutationFn: (body) =>
      api.post<{ ok: boolean }>('/api/stats/manual', { appId, ...body }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['cockpit'] })
      void qc.invalidateQueries({ queryKey: ['stats'] })
    },
  })
}
